import { func } from 'prop-types';
import { memo } from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';

import AlertMessage from 'components/common/AlertMessage';
import Input from 'components/common/Input';
import CenteredLoading from 'components/common/Loading/CenteredLoading';
import { useForm, useValidation, useTextInputProps, useStatus } from 'hooks';
import { signUp } from 'state/actions/userActions';
import { signUp as signUpValidations } from 'utils/constraints';

const messages = defineMessages({
  email: { id: 'common.email' },
  password: { id: 'common.password' },
  passConfirmation: { id: 'common.cap.passwordConfirmation' }
});

const fields = {
  email: 'email',
  password: 'password',
  passwordConfirmation: 'passwordConfirmation'
};

export const SignUpForm = ({ onSubmit }) => {
  const intl = useIntl();
  const { isPending, isRejected, error } = useStatus(signUp);

  const validator = useValidation(signUpValidations);
  const { values, errors, handleValueChange, handleSubmit, handleBlur } = useForm(
    {
      onSubmit,
      validator,
      validateOnBlur: true
    },
    [onSubmit]
  );

  const inputProps = useTextInputProps({ handleValueChange, handleBlur, values, errors });

  return (
    <form onSubmit={handleSubmit}>
      {isRejected && <AlertMessage>{error}</AlertMessage>}
      <div>
        <Input
          name="email"
          label={intl.formatMessage(messages.email)}
          type="email"
          {...inputProps(fields.email)}
        />
      </div>
      <div>
        <Input
          name="password"
          label={intl.formatMessage(messages.password)}
          type="password"
          {...inputProps(fields.password)}
        />
      </div>
      <div>
        <Input
          name="passwordConfirmation"
          label={intl.formatMessage(messages.passConfirmation)}
          type="password"
          {...inputProps(fields.passwordConfirmation)}
        />
      </div>
      <button type="submit">
        <FormattedMessage id="common.cap.signIn" />
      </button>
      {isPending && <CenteredLoading />}
    </form>
  );
};

SignUpForm.propTypes = {
  onSubmit: func.isRequired
};

export default memo(SignUpForm);
